<template>
  <b-tab>
    <template v-slot:title>Investment & Returns</template>
    <div>

      <!-- Major Permissions -->
      <h4 class="text-black">View Returns</h4>
      <div class="mb-2 border-bottom row" v-for="(item, index) in permissions" :key="index">
        <div class="col-2">{{ item.rolename }}</div>
        <div class="col">
          <RockerSwitch v-if="item.view_returns == 1" :value="true"
            @change="changePermission(role = item.role, permission = 'view_returns')" />
          <RockerSwitch v-else :value="false"
            @change="changePermission(role = item.role, permission = 'view_returns')" />
        </div>
      </div>

      <!-- Major Permissions: Investment Returns -->
      <h4 class="text-black mt-4">View Investment Returns</h4>
      <div class="mb-2 border-bottom row" v-for="(item, index) in permissions" :key="'inv-ret-' + index">
        <div class="col-2">{{ item.rolename }}</div>
        <div class="col">
          <RockerSwitch v-if="item.view_investment_returns == 1" :value="true"
            @change="changePermission(role = item.role, permission = 'view_investment_returns')" />
          <RockerSwitch v-else :value="false"
            @change="changePermission(role = item.role, permission = 'view_investment_returns')" />
        </div>
      </div>

      <div>
        <!-- Headings -->
        <div class="row fw-bold text-black mb-2">
          <div class="col-2">Role Name</div>
          <div class="col-2">View Investments</div>
          <div class="col-2">View Member Interests</div>
          <div class="col-2">View Interest Payouts</div>
          <div class="col-2">Shareholder Dividends</div>
          <div class="col-2">Dividend Payouts</div>
        </div>
        <!-- Data -->
        <div class="row mb-2 border-bottom" v-for="item in filteredPermissions" :key="item.id">
          <div class="col-2">{{ item.rolename }}</div>

          <!-- View Investments -->
          <div class="col-2">
            <RockerSwitch v-if="item.view_investment == 1" :value="true"
              @change="changePermission(role = item.role, permission = 'view_investment')" />
            <RockerSwitch v-else :value="false"
              @change="changePermission(role = item.role, permission = 'view_investment')" />
          </div>

          <!-- View Member Interests -->
          <div class="col-2">
            <RockerSwitch v-if="item.member_interests == 1" :value="true"
              @change="changePermission(role = item.role, permission = 'member_interests')" />
            <RockerSwitch v-else :value="false"
              @change="changePermission(role = item.role, permission = 'member_interests')" />
          </div>

          <!-- View Interest Payouts -->
          <div class="col-2">
            <RockerSwitch v-if="item.interest_payouts == 1" :value="true"
              @change="changePermission(role = item.role, permission = 'interest_payouts')" />
            <RockerSwitch v-else :value="false"
              @change="changePermission(role = item.role, permission = 'interest_payouts')" />
          </div>

          <!-- Shareholder Dividends -->
          <div class="col-2">
            <RockerSwitch v-if="item.share_holder_dividends == 1" :value="true"
              @change="changePermission(role = item.role, permission = 'share_holder_dividends')" />
            <RockerSwitch v-else :value="false"
              @change="changePermission(role = item.role, permission = 'share_holder_dividends')" />
          </div>

          <!-- Dividend Payouts -->
          <div class="col-2">
            <RockerSwitch v-if="item.dividend_payouts == 1" :value="true"
              @change="changePermission(role = item.role, permission = 'dividend_payouts')" />
            <RockerSwitch v-else :value="false"
              @change="changePermission(role = item.role, permission = 'dividend_payouts')" />
          </div>
        </div>
      </div>
    </div>
  </b-tab>
</template>

<script>
import axios from "axios";
import RockerSwitch from "vue-rocker-switch";
import "vue-rocker-switch/dist/vue-rocker-switch.css";

import appConfig from "@/app.config";
import { permissionMethods } from "@/state/helpers";

export default {
  name: "ReturnPermissions",
  page: {
    title: "System Permissions",
    meta: [{ name: "description", content: appConfig.description, },],
  },
  props: {
    permissions: Array,
  },
  components: {
    RockerSwitch
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      title: "System Permissions",
      items: [{ text: "Dashboard", to: "/", }, { text: "System Permissions", active: true, },],
      isBusy: true,
      role: '',
      permission: '',
    };
  },
  computed: {
    filteredPermissions() {
      return this.permissions.filter((permission) => permission.view_returns == 1);
    },
  },

  methods: {
    ...permissionMethods,
    async changePermission(role, permission) {
      this.role = role;
      this.permission = permission;
      let formData = new FormData();
      formData.append("role", this.role);
      formData.append("permission", this.permission);
      let url = "/updatepermission";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchPermissions();
          this.role = "";
          this.permission = "";
        }
      });
    },
  },
};
</script>